/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { Bizo, autoclass } from '@zcode/bizos'
import type { POIs, RawPOIs } from '@zcode/state-type'

// NOTE: here I'm using the original snake_case attributes to match the POI categories
const POIS_DEFINITION = {
  bus_stops: 'bus_stops',
  cafes: 'cafes',
  groceries: 'groceries',
  nightlife: 'nightlife',
  parks: 'parks',
  rapid_transit_stations: 'rapid_transit_stations',
  restaurants: 'restaurants',
  train_stations: 'train_stations',
} as const

export const Pois = autoclass<POIs, RawPOIs>(
  'Pois',
  class Pois extends Bizo<POIs, RawPOIs> {},
  POIS_DEFINITION,
  null
)
